/** LyX math panels (lib/ui/stdtoolbars.inc), generated by scripts/gen-math-panels.py — do not edit. */
export interface PanelItem { label: string; kind: "insert" | "size"; latex: string }
export interface MathPanel { id: string; title: string; items: PanelItem[] }
export const MATH_PANELS: MathPanel[] = [
  { id: 'functions', title: 'Functions', items: [
    { label: 'arccos', kind: 'insert', latex: '\\arccos' },
    { label: 'arcsin', kind: 'insert', latex: '\\arcsin' },
    { label: 'arctan', kind: 'insert', latex: '\\arctan' },
    { label: 'arg', kind: 'insert', latex: '\\arg' },
    { label: 'bmod', kind: 'insert', latex: '\\bmod' },
    { label: 'cos', kind: 'insert', latex: '\\cos' },
    { label: 'cosh', kind: 'insert', latex: '\\cosh' },
    { label: 'cot', kind: 'insert', latex: '\\cot' },
    { label: 'coth', kind: 'insert', latex: '\\coth' },
    { label: 'csc', kind: 'insert', latex: '\\csc' },
    { label: 'deg', kind: 'insert', latex: '\\deg' },
    { label: 'det', kind: 'insert', latex: '\\det' },
    { label: 'dim', kind: 'insert', latex: '\\dim' },
    { label: 'exp', kind: 'insert', latex: '\\exp' },
    { label: 'gcd', kind: 'insert', latex: '\\gcd' },
    { label: 'hom', kind: 'insert', latex: '\\hom' },
    { label: 'inf', kind: 'insert', latex: '\\inf' },
    { label: 'ker', kind: 'insert', latex: '\\ker' },
    { label: 'lg', kind: 'insert', latex: '\\lg' },
    { label: 'lim', kind: 'insert', latex: '\\lim' },
    { label: 'liminf', kind: 'insert', latex: '\\liminf' },
    { label: 'limsup', kind: 'insert', latex: '\\limsup' },
    { label: 'ln', kind: 'insert', latex: '\\ln' },
    { label: 'log', kind: 'insert', latex: '\\log' },
    { label: 'max', kind: 'insert', latex: '\\max' },
    { label: 'min', kind: 'insert', latex: '\\min' },
    { label: 'sec', kind: 'insert', latex: '\\sec' },
    { label: 'sin', kind: 'insert', latex: '\\sin' },
    { label: 'sinh', kind: 'insert', latex: '\\sinh' },
    { label: 'sup', kind: 'insert', latex: '\\sup' },
    { label: 'tan', kind: 'insert', latex: '\\tan' },
    { label: 'tanh', kind: 'insert', latex: '\\tanh' },
    { label: 'Pr', kind: 'insert', latex: '\\Pr' },
  ] },
  { id: 'space', title: 'Spacings', items: [
    { label: 'Thin space', kind: 'insert', latex: '\\,' },
    { label: 'Medium space', kind: 'insert', latex: '\\:' },
    { label: 'Thick space', kind: 'insert', latex: '\\;' },
    { label: 'Quadratin space', kind: 'insert', latex: '\\quad' },
    { label: 'Double quadratin space', kind: 'insert', latex: '\\qquad' },
    { label: 'Negative space', kind: 'insert', latex: '\\!' },
    { label: 'Phantom', kind: 'insert', latex: '\\phantom' },
    { label: 'Horizontal phantom', kind: 'insert', latex: '\\hphantom' },
    { label: 'Vertical phantom', kind: 'insert', latex: '\\vphantom' },
    { label: 'Smash', kind: 'insert', latex: '\\smash' },
    { label: 'Top smash', kind: 'insert', latex: '\\smasht' },
    { label: 'Bottom smash', kind: 'insert', latex: '\\smashb' },
    { label: 'Left overlap', kind: 'insert', latex: '\\mathllap' },
    { label: 'Center overlap', kind: 'insert', latex: '\\mathclap' },
    { label: 'Right overlap', kind: 'insert', latex: '\\mathrlap' },
  ] },
  { id: 'sqrt-square', title: 'Roots', items: [
    { label: 'Square root', kind: 'insert', latex: '\\sqrt' },
    { label: 'Other root', kind: 'insert', latex: '\\root' },
  ] },
  { id: 'style', title: 'Styles & Classes', items: [
    { label: 'Display style', kind: 'size', latex: '\\displaystyle' },
    { label: 'Normal text style', kind: 'size', latex: '\\textstyle' },
    { label: 'Script (small) style', kind: 'size', latex: '\\scriptstyle' },
    { label: 'Scriptscript (smaller) style', kind: 'size', latex: '\\scriptscriptstyle' },
    { label: 'Relation class', kind: 'insert', latex: '\\mathrel' },
    { label: 'Binary operator class', kind: 'insert', latex: '\\mathbin' },
    { label: 'Large operator class', kind: 'insert', latex: '\\mathop' },
    { label: 'Ordinary class', kind: 'insert', latex: '\\mathord' },
  ] },
  { id: 'frac-square', title: 'Fractions', items: [
    { label: 'Standard', kind: 'insert', latex: '\\frac' },
    { label: 'Nice fraction (3/4)', kind: 'insert', latex: '\\nicefrac' },
    { label: 'Unit (km)', kind: 'insert', latex: '\\unitone' },
    { label: 'Unit (864 m)', kind: 'insert', latex: '\\unittwo' },
    { label: 'Unit fraction (km/h)', kind: 'insert', latex: '\\unitfrac' },
    { label: 'Unit fraction (20 km/h)', kind: 'insert', latex: '\\unitfracthree' },
    { label: 'Text fraction', kind: 'insert', latex: '\\tfrac' },
    { label: 'Display fraction', kind: 'insert', latex: '\\dfrac' },
    { label: 'Continued fraction', kind: 'insert', latex: '\\cfrac' },
    { label: 'Continued fraction (left)', kind: 'insert', latex: '\\cfracleft' },
    { label: 'Continued fraction (right)', kind: 'insert', latex: '\\cfracright' },
    { label: 'Binomial', kind: 'insert', latex: '\\binom' },
    { label: 'Text binomial', kind: 'insert', latex: '\\tbinom' },
    { label: 'Display binomial', kind: 'insert', latex: '\\dbinom' },
  ] },
  { id: 'font', title: 'Fonts', items: [
    { label: 'Roman', kind: 'insert', latex: '\\mathrm' },
    { label: 'Bold', kind: 'insert', latex: '\\mathbf' },
    { label: 'Bold symbol', kind: 'insert', latex: '\\boldsymbol' },
    { label: 'Sans serif', kind: 'insert', latex: '\\mathsf' },
    { label: 'Italic', kind: 'insert', latex: '\\mathit' },
    { label: 'Typewriter', kind: 'insert', latex: '\\mathtt' },
    { label: 'Blackboard', kind: 'insert', latex: '\\mathbb' },
    { label: 'Double stroke', kind: 'insert', latex: '\\mathds' },
    { label: 'Fraktur', kind: 'insert', latex: '\\mathfrak' },
    { label: 'Calligraphic', kind: 'insert', latex: '\\mathcal' },
    { label: 'Formal Script', kind: 'insert', latex: '\\mathscr' },
    { label: 'Normal text mode', kind: 'insert', latex: '\\textrm' },
  ] },
  { id: 'latex_dots', title: 'Dots', items: [
    { label: 'ldots', kind: 'insert', latex: '\\ldots' },
    { label: 'cdots', kind: 'insert', latex: '\\cdots' },
    { label: 'vdots', kind: 'insert', latex: '\\vdots' },
    { label: 'ddots', kind: 'insert', latex: '\\ddots' },
    { label: 'iddots', kind: 'insert', latex: '\\iddots' },
  ] },
  { id: 'latex_deco', title: 'Frame Decorations', items: [
    { label: 'hat', kind: 'insert', latex: '\\hat' },
    { label: 'tilde', kind: 'insert', latex: '\\tilde' },
    { label: 'bar', kind: 'insert', latex: '\\bar' },
    { label: 'grave', kind: 'insert', latex: '\\grave' },
    { label: 'dot', kind: 'insert', latex: '\\dot' },
    { label: 'check', kind: 'insert', latex: '\\check' },
    { label: 'widehat', kind: 'insert', latex: '\\widehat' },
    { label: 'widetilde', kind: 'insert', latex: '\\widetilde' },
    { label: 'utilde', kind: 'insert', latex: '\\utilde' },
    { label: 'vec', kind: 'insert', latex: '\\vec' },
    { label: 'acute', kind: 'insert', latex: '\\acute' },
    { label: 'ddot', kind: 'insert', latex: '\\ddot' },
    { label: 'dddot', kind: 'insert', latex: '\\dddot' },
    { label: 'ddddot', kind: 'insert', latex: '\\ddddot' },
    { label: 'breve', kind: 'insert', latex: '\\breve' },
    { label: 'mathring', kind: 'insert', latex: '\\mathring' },
    { label: 'overline', kind: 'insert', latex: '\\overline' },
    { label: 'overbrace', kind: 'insert', latex: '\\overbrace' },
    { label: 'overleftarrow', kind: 'insert', latex: '\\overleftarrow' },
    { label: 'overrightarrow', kind: 'insert', latex: '\\overrightarrow' },
    { label: 'overleftrightarrow', kind: 'insert', latex: '\\overleftrightarrow' },
    { label: 'underline', kind: 'insert', latex: '\\underline' },
    { label: 'underbrace', kind: 'insert', latex: '\\underbrace' },
    { label: 'underleftarrow', kind: 'insert', latex: '\\underleftarrow' },
    { label: 'underrightarrow', kind: 'insert', latex: '\\underrightarrow' },
    { label: 'underleftrightarrow', kind: 'insert', latex: '\\underleftrightarrow' },
    { label: 'cancel', kind: 'insert', latex: '\\cancel' },
    { label: 'bcancel', kind: 'insert', latex: '\\bcancel' },
    { label: 'xcancel', kind: 'insert', latex: '\\xcancel' },
    { label: 'cancelto', kind: 'insert', latex: '\\cancelto' },
    { label: 'Insert left/right side scripts (sideset)', kind: 'insert', latex: '\\sideset' },
    { label: 'Insert right side scripts (sidesetr)', kind: 'insert', latex: '\\sidesetr' },
    { label: 'Insert left side scripts (sidesetl)', kind: 'insert', latex: '\\sidesetl' },
    { label: 'Insert side scripts (sidesetn)', kind: 'insert', latex: '\\sidesetn' },
    { label: 'overset', kind: 'insert', latex: '\\overset' },
    { label: 'underset', kind: 'insert', latex: '\\underset' },
    { label: 'stackrel', kind: 'insert', latex: '\\stackrel' },
    { label: 'stackrelthree', kind: 'insert', latex: '\\stackrelthree' },
  ] },
  { id: 'latex_arrow', title: 'Arrows', items: [
    { label: 'leftarrow', kind: 'insert', latex: '\\leftarrow' },
    { label: 'rightarrow', kind: 'insert', latex: '\\rightarrow' },
    { label: 'downarrow', kind: 'insert', latex: '\\downarrow' },
    { label: 'uparrow', kind: 'insert', latex: '\\uparrow' },
    { label: 'updownarrow', kind: 'insert', latex: '\\updownarrow' },
    { label: 'leftrightarrow', kind: 'insert', latex: '\\leftrightarrow' },
    { label: 'Leftarrow', kind: 'insert', latex: '\\Leftarrow' },
    { label: 'Rightarrow', kind: 'insert', latex: '\\Rightarrow' },
    { label: 'Downarrow', kind: 'insert', latex: '\\Downarrow' },
    { label: 'Uparrow', kind: 'insert', latex: '\\Uparrow' },
    { label: 'Updownarrow', kind: 'insert', latex: '\\Updownarrow' },
    { label: 'Leftrightarrow', kind: 'insert', latex: '\\Leftrightarrow' },
    { label: 'Longleftrightarrow', kind: 'insert', latex: '\\Longleftrightarrow' },
    { label: 'Longleftarrow', kind: 'insert', latex: '\\Longleftarrow' },
    { label: 'Longrightarrow', kind: 'insert', latex: '\\Longrightarrow' },
    { label: 'longleftrightarrow', kind: 'insert', latex: '\\longleftrightarrow' },
    { label: 'longleftarrow', kind: 'insert', latex: '\\longleftarrow' },
    { label: 'longrightarrow', kind: 'insert', latex: '\\longrightarrow' },
    { label: 'leftharpoondown', kind: 'insert', latex: '\\leftharpoondown' },
    { label: 'rightharpoondown', kind: 'insert', latex: '\\rightharpoondown' },
    { label: 'mapsto', kind: 'insert', latex: '\\mapsto' },
    { label: 'longmapsto', kind: 'insert', latex: '\\longmapsto' },
    { label: 'nwarrow', kind: 'insert', latex: '\\nwarrow' },
    { label: 'nearrow', kind: 'insert', latex: '\\nearrow' },
    { label: 'leftharpoonup', kind: 'insert', latex: '\\leftharpoonup' },
    { label: 'rightharpoonup', kind: 'insert', latex: '\\rightharpoonup' },
    { label: 'hookleftarrow', kind: 'insert', latex: '\\hookleftarrow' },
    { label: 'hookrightarrow', kind: 'insert', latex: '\\hookrightarrow' },
    { label: 'swarrow', kind: 'insert', latex: '\\swarrow' },
    { label: 'searrow', kind: 'insert', latex: '\\searrow' },
    { label: 'rightleftharpoons', kind: 'insert', latex: '\\rightleftharpoons' },
  ] },
  { id: 'latex_bop', title: 'Operators', items: [
    { label: 'pm', kind: 'insert', latex: '\\pm' },
    { label: 'cap', kind: 'insert', latex: '\\cap' },
    { label: 'diamond', kind: 'insert', latex: '\\diamond' },
    { label: 'oplus', kind: 'insert', latex: '\\oplus' },
    { label: 'mp', kind: 'insert', latex: '\\mp' },
    { label: 'cup', kind: 'insert', latex: '\\cup' },
    { label: 'bigtriangleup', kind: 'insert', latex: '\\bigtriangleup' },
    { label: 'ominus', kind: 'insert', latex: '\\ominus' },
    { label: 'times', kind: 'insert', latex: '\\times' },
    { label: 'uplus', kind: 'insert', latex: '\\uplus' },
    { label: 'bigtriangledown', kind: 'insert', latex: '\\bigtriangledown' },
    { label: 'otimes', kind: 'insert', latex: '\\otimes' },
    { label: 'div', kind: 'insert', latex: '\\div' },
    { label: 'sqcap', kind: 'insert', latex: '\\sqcap' },
    { label: 'triangleright', kind: 'insert', latex: '\\triangleright' },
    { label: 'oslash', kind: 'insert', latex: '\\oslash' },
    { label: 'cdot', kind: 'insert', latex: '\\cdot' },
    { label: 'sqcup', kind: 'insert', latex: '\\sqcup' },
    { label: 'triangleleft', kind: 'insert', latex: '\\triangleleft' },
    { label: 'odot', kind: 'insert', latex: '\\odot' },
    { label: 'star', kind: 'insert', latex: '\\star' },
    { label: 'ast', kind: 'insert', latex: '\\ast' },
    { label: 'vee', kind: 'insert', latex: '\\vee' },
    { label: 'amalg', kind: 'insert', latex: '\\amalg' },
    { label: 'bigcirc', kind: 'insert', latex: '\\bigcirc' },
    { label: 'setminus', kind: 'insert', latex: '\\setminus' },
    { label: 'wedge', kind: 'insert', latex: '\\wedge' },
    { label: 'dagger', kind: 'insert', latex: '\\dagger' },
    { label: 'circ', kind: 'insert', latex: '\\circ' },
    { label: 'bullet', kind: 'insert', latex: '\\bullet' },
    { label: 'wr', kind: 'insert', latex: '\\wr' },
    { label: 'ddagger', kind: 'insert', latex: '\\ddagger' },
    { label: 'smallint', kind: 'insert', latex: '\\smallint' },
  ] },
  { id: 'latex_brel', title: 'Relations', items: [
    { label: 'leq', kind: 'insert', latex: '\\leq' },
    { label: 'geq', kind: 'insert', latex: '\\geq' },
    { label: 'equiv', kind: 'insert', latex: '\\equiv' },
    { label: 'models', kind: 'insert', latex: '\\models' },
    { label: 'prec', kind: 'insert', latex: '\\prec' },
    { label: 'succ', kind: 'insert', latex: '\\succ' },
    { label: 'sim', kind: 'insert', latex: '\\sim' },
    { label: 'perp', kind: 'insert', latex: '\\perp' },
    { label: 'preceq', kind: 'insert', latex: '\\preceq' },
    { label: 'succeq', kind: 'insert', latex: '\\succeq' },
    { label: 'simeq', kind: 'insert', latex: '\\simeq' },
    { label: 'mid', kind: 'insert', latex: '\\mid' },
    { label: 'll', kind: 'insert', latex: '\\ll' },
    { label: 'gg', kind: 'insert', latex: '\\gg' },
    { label: 'asymp', kind: 'insert', latex: '\\asymp' },
    { label: 'parallel', kind: 'insert', latex: '\\parallel' },
    { label: 'subset', kind: 'insert', latex: '\\subset' },
    { label: 'supset', kind: 'insert', latex: '\\supset' },
    { label: 'approx', kind: 'insert', latex: '\\approx' },
    { label: 'smile', kind: 'insert', latex: '\\smile' },
    { label: 'subseteq', kind: 'insert', latex: '\\subseteq' },
    { label: 'supseteq', kind: 'insert', latex: '\\supseteq' },
    { label: 'cong', kind: 'insert', latex: '\\cong' },
    { label: 'frown', kind: 'insert', latex: '\\frown' },
    { label: 'sqsubseteq', kind: 'insert', latex: '\\sqsubseteq' },
    { label: 'sqsupseteq', kind: 'insert', latex: '\\sqsupseteq' },
    { label: 'doteq', kind: 'insert', latex: '\\doteq' },
    { label: 'neq', kind: 'insert', latex: '\\neq' },
    { label: 'in', kind: 'insert', latex: '\\in' },
    { label: 'ni', kind: 'insert', latex: '\\ni' },
    { label: 'propto', kind: 'insert', latex: '\\propto' },
    { label: 'notin', kind: 'insert', latex: '\\notin' },
    { label: 'vdash', kind: 'insert', latex: '\\vdash' },
    { label: 'dashv', kind: 'insert', latex: '\\dashv' },
    { label: 'bowtie', kind: 'insert', latex: '\\bowtie' },
    { label: 'iff', kind: 'insert', latex: '\\iff' },
    { label: 'not', kind: 'insert', latex: '\\not' },
    { label: 'land', kind: 'insert', latex: '\\land' },
    { label: 'lor', kind: 'insert', latex: '\\lor' },
    { label: 'lnot', kind: 'insert', latex: '\\lnot' },
  ] },
  { id: 'latex_greek', title: 'Greek', items: [
    { label: 'alpha', kind: 'insert', latex: '\\alpha' },
    { label: 'beta', kind: 'insert', latex: '\\beta' },
    { label: 'gamma', kind: 'insert', latex: '\\gamma' },
    { label: 'delta', kind: 'insert', latex: '\\delta' },
    { label: 'epsilon', kind: 'insert', latex: '\\epsilon' },
    { label: 'varepsilon', kind: 'insert', latex: '\\varepsilon' },
    { label: 'zeta', kind: 'insert', latex: '\\zeta' },
    { label: 'eta', kind: 'insert', latex: '\\eta' },
    { label: 'theta', kind: 'insert', latex: '\\theta' },
    { label: 'vartheta', kind: 'insert', latex: '\\vartheta' },
    { label: 'iota', kind: 'insert', latex: '\\iota' },
    { label: 'kappa', kind: 'insert', latex: '\\kappa' },
    { label: 'lambda', kind: 'insert', latex: '\\lambda' },
    { label: 'mu', kind: 'insert', latex: '\\mu' },
    { label: 'nu', kind: 'insert', latex: '\\nu' },
    { label: 'xi', kind: 'insert', latex: '\\xi' },
    { label: 'pi', kind: 'insert', latex: '\\pi' },
    { label: 'varpi', kind: 'insert', latex: '\\varpi' },
    { label: 'rho', kind: 'insert', latex: '\\rho' },
    { label: 'varrho', kind: 'insert', latex: '\\varrho' },
    { label: 'sigma', kind: 'insert', latex: '\\sigma' },
    { label: 'varsigma', kind: 'insert', latex: '\\varsigma' },
    { label: 'tau', kind: 'insert', latex: '\\tau' },
    { label: 'upsilon', kind: 'insert', latex: '\\upsilon' },
    { label: 'phi', kind: 'insert', latex: '\\phi' },
    { label: 'varphi', kind: 'insert', latex: '\\varphi' },
    { label: 'chi', kind: 'insert', latex: '\\chi' },
    { label: 'psi', kind: 'insert', latex: '\\psi' },
    { label: 'omega', kind: 'insert', latex: '\\omega' },
    { label: 'Gamma', kind: 'insert', latex: '\\Gamma' },
    { label: 'Delta', kind: 'insert', latex: '\\Delta' },
    { label: 'Theta', kind: 'insert', latex: '\\Theta' },
    { label: 'Lambda', kind: 'insert', latex: '\\Lambda' },
    { label: 'Xi', kind: 'insert', latex: '\\Xi' },
    { label: 'Pi', kind: 'insert', latex: '\\Pi' },
    { label: 'Sigma', kind: 'insert', latex: '\\Sigma' },
    { label: 'Upsilon', kind: 'insert', latex: '\\Upsilon' },
    { label: 'Phi', kind: 'insert', latex: '\\Phi' },
    { label: 'Psi', kind: 'insert', latex: '\\Psi' },
    { label: 'Omega', kind: 'insert', latex: '\\Omega' },
    { label: 'varGamma', kind: 'insert', latex: '\\varGamma' },
    { label: 'varDelta', kind: 'insert', latex: '\\varDelta' },
    { label: 'varTheta', kind: 'insert', latex: '\\varTheta' },
    { label: 'varLambda', kind: 'insert', latex: '\\varLambda' },
    { label: 'varXi', kind: 'insert', latex: '\\varXi' },
    { label: 'varPi', kind: 'insert', latex: '\\varPi' },
    { label: 'varSigma', kind: 'insert', latex: '\\varSigma' },
    { label: 'varUpsilon', kind: 'insert', latex: '\\varUpsilon' },
    { label: 'varPhi', kind: 'insert', latex: '\\varPhi' },
    { label: 'varPsi', kind: 'insert', latex: '\\varPsi' },
    { label: 'varOmega', kind: 'insert', latex: '\\varOmega' },
  ] },
  { id: 'latex_misc', title: 'Miscellaneous', items: [
    { label: 'nabla', kind: 'insert', latex: '\\nabla' },
    { label: 'partial', kind: 'insert', latex: '\\partial' },
    { label: 'infty', kind: 'insert', latex: '\\infty' },
    { label: 'prime', kind: 'insert', latex: '\\prime' },
    { label: 'ell', kind: 'insert', latex: '\\ell' },
    { label: 'emptyset', kind: 'insert', latex: '\\emptyset' },
    { label: 'exists', kind: 'insert', latex: '\\exists' },
    { label: 'forall', kind: 'insert', latex: '\\forall' },
    { label: 'imath', kind: 'insert', latex: '\\imath' },
    { label: 'jmath', kind: 'insert', latex: '\\jmath' },
    { label: 'Re', kind: 'insert', latex: '\\Re' },
    { label: 'Im', kind: 'insert', latex: '\\Im' },
    { label: 'aleph', kind: 'insert', latex: '\\aleph' },
    { label: 'wp', kind: 'insert', latex: '\\wp' },
    { label: 'hbar', kind: 'insert', latex: '\\hbar' },
    { label: 'angle', kind: 'insert', latex: '\\angle' },
    { label: 'top', kind: 'insert', latex: '\\top' },
    { label: 'bot', kind: 'insert', latex: '\\bot' },
    { label: 'Vert', kind: 'insert', latex: '\\Vert' },
    { label: 'neg', kind: 'insert', latex: '\\neg' },
    { label: 'flat', kind: 'insert', latex: '\\flat' },
    { label: 'natural', kind: 'insert', latex: '\\natural' },
    { label: 'sharp', kind: 'insert', latex: '\\sharp' },
    { label: 'surd', kind: 'insert', latex: '\\surd' },
    { label: 'lhook', kind: 'insert', latex: '\\lhook' },
    { label: 'rhook', kind: 'insert', latex: '\\rhook' },
    { label: 'triangle', kind: 'insert', latex: '\\triangle' },
    { label: 'diamondsuit', kind: 'insert', latex: '\\diamondsuit' },
    { label: 'heartsuit', kind: 'insert', latex: '\\heartsuit' },
    { label: 'clubsuit', kind: 'insert', latex: '\\clubsuit' },
    { label: 'spadesuit', kind: 'insert', latex: '\\spadesuit' },
    { label: 'textrm \\AA', kind: 'insert', latex: '\\textrm \\AA' },
    { label: 'textrm \\O', kind: 'insert', latex: '\\textrm \\O' },
    { label: 'mathcircumflex', kind: 'insert', latex: '\\mathcircumflex' },
    { label: '_', kind: 'insert', latex: '\\_' },
    { label: 'textdegree', kind: 'insert', latex: '\\textdegree' },
    { label: 'mathdollar', kind: 'insert', latex: '\\mathdollar' },
    { label: 'mathparagraph', kind: 'insert', latex: '\\mathparagraph' },
    { label: 'mathsection', kind: 'insert', latex: '\\mathsection' },
    { label: 'mathrm T', kind: 'insert', latex: '\\mathrm T' },
    { label: 'mathbb N', kind: 'insert', latex: '\\mathbb N' },
    { label: 'mathbb Z', kind: 'insert', latex: '\\mathbb Z' },
    { label: 'mathbb Q', kind: 'insert', latex: '\\mathbb Q' },
    { label: 'mathbb R', kind: 'insert', latex: '\\mathbb R' },
    { label: 'mathbb C', kind: 'insert', latex: '\\mathbb C' },
    { label: 'mathbb H', kind: 'insert', latex: '\\mathbb H' },
    { label: 'mathcal F', kind: 'insert', latex: '\\mathcal F' },
    { label: 'mathcal L', kind: 'insert', latex: '\\mathcal L' },
    { label: 'mathcal H', kind: 'insert', latex: '\\mathcal H' },
    { label: 'mathcal O', kind: 'insert', latex: '\\mathcal O' },
  ] },
  { id: 'latex_varsz', title: 'Big Operators', items: [
    { label: 'intop', kind: 'insert', latex: '\\intop' },
    { label: 'int', kind: 'insert', latex: '\\int' },
    { label: 'iint', kind: 'insert', latex: '\\iint' },
    { label: 'iintop', kind: 'insert', latex: '\\iintop' },
    { label: 'iiint', kind: 'insert', latex: '\\iiint' },
    { label: 'iiintop', kind: 'insert', latex: '\\iiintop' },
    { label: 'iiiint', kind: 'insert', latex: '\\iiiint' },
    { label: 'iiiintop', kind: 'insert', latex: '\\iiiintop' },
    { label: 'dotsint', kind: 'insert', latex: '\\dotsint' },
    { label: 'dotsintop', kind: 'insert', latex: '\\dotsintop' },
    { label: 'idotsint', kind: 'insert', latex: '\\idotsint' },
    { label: 'oint', kind: 'insert', latex: '\\oint' },
    { label: 'ointop', kind: 'insert', latex: '\\ointop' },
    { label: 'oiint', kind: 'insert', latex: '\\oiint' },
    { label: 'oiintop', kind: 'insert', latex: '\\oiintop' },
    { label: 'ointctrclockwiseop', kind: 'insert', latex: '\\ointctrclockwiseop' },
    { label: 'ointctrclockwise', kind: 'insert', latex: '\\ointctrclockwise' },
    { label: 'ointclockwiseop', kind: 'insert', latex: '\\ointclockwiseop' },
    { label: 'ointclockwise', kind: 'insert', latex: '\\ointclockwise' },
    { label: 'sqint', kind: 'insert', latex: '\\sqint' },
    { label: 'sqintop', kind: 'insert', latex: '\\sqintop' },
    { label: 'sqiint', kind: 'insert', latex: '\\sqiint' },
    { label: 'sqiintop', kind: 'insert', latex: '\\sqiintop' },
    { label: 'fint', kind: 'insert', latex: '\\fint' },
    { label: 'fintop', kind: 'insert', latex: '\\fintop' },
    { label: 'landupint', kind: 'insert', latex: '\\landupint' },
    { label: 'landupintop', kind: 'insert', latex: '\\landupintop' },
    { label: 'landdownint', kind: 'insert', latex: '\\landdownint' },
    { label: 'landdownintop', kind: 'insert', latex: '\\landdownintop' },
    { label: 'varint', kind: 'insert', latex: '\\varint' },
    { label: 'varoint', kind: 'insert', latex: '\\varoint' },
    { label: 'varoiint', kind: 'insert', latex: '\\varoiint' },
    { label: 'varoiintop', kind: 'insert', latex: '\\varoiintop' },
    { label: 'varointclockwise', kind: 'insert', latex: '\\varointclockwise' },
    { label: 'varointclockwiseop', kind: 'insert', latex: '\\varointclockwiseop' },
    { label: 'varointctrclockwise', kind: 'insert', latex: '\\varointctrclockwise' },
    { label: 'varointctrclockwiseop', kind: 'insert', latex: '\\varointctrclockwiseop' },
    { label: 'sum', kind: 'insert', latex: '\\sum' },
    { label: 'prod', kind: 'insert', latex: '\\prod' },
    { label: 'coprod', kind: 'insert', latex: '\\coprod' },
    { label: 'bigsqcup', kind: 'insert', latex: '\\bigsqcup' },
    { label: 'bigotimes', kind: 'insert', latex: '\\bigotimes' },
    { label: 'bigodot', kind: 'insert', latex: '\\bigodot' },
    { label: 'bigoplus', kind: 'insert', latex: '\\bigoplus' },
    { label: 'bigcap', kind: 'insert', latex: '\\bigcap' },
    { label: 'bigcup', kind: 'insert', latex: '\\bigcup' },
    { label: 'biguplus', kind: 'insert', latex: '\\biguplus' },
    { label: 'bigvee', kind: 'insert', latex: '\\bigvee' },
    { label: 'bigwedge', kind: 'insert', latex: '\\bigwedge' },
  ] },
  { id: 'latex_ams_misc', title: 'Miscellaneous (extended)', items: [
    { label: 'digamma', kind: 'insert', latex: '\\digamma' },
    { label: 'varkappa', kind: 'insert', latex: '\\varkappa' },
    { label: 'beth', kind: 'insert', latex: '\\beth' },
    { label: 'daleth', kind: 'insert', latex: '\\daleth' },
    { label: 'gimel', kind: 'insert', latex: '\\gimel' },
    { label: 'ulcorner', kind: 'insert', latex: '\\ulcorner' },
    { label: 'urcorner', kind: 'insert', latex: '\\urcorner' },
    { label: 'llcorner', kind: 'insert', latex: '\\llcorner' },
    { label: 'lrcorner', kind: 'insert', latex: '\\lrcorner' },
    { label: 'hbar', kind: 'insert', latex: '\\hbar' },
    { label: 'hslash', kind: 'insert', latex: '\\hslash' },
    { label: 'vartriangle', kind: 'insert', latex: '\\vartriangle' },
    { label: 'triangledown', kind: 'insert', latex: '\\triangledown' },
    { label: 'square', kind: 'insert', latex: '\\square' },
    { label: 'Square', kind: 'insert', latex: '\\Square' },
    { label: 'CheckedBox', kind: 'insert', latex: '\\CheckedBox' },
    { label: 'XBox', kind: 'insert', latex: '\\XBox' },
    { label: 'lozenge', kind: 'insert', latex: '\\lozenge' },
    { label: 'wasylozenge', kind: 'insert', latex: '\\wasylozenge' },
    { label: 'circledR', kind: 'insert', latex: '\\circledR' },
    { label: 'circledS', kind: 'insert', latex: '\\circledS' },
    { label: 'measuredangle', kind: 'insert', latex: '\\measuredangle' },
    { label: 'varangle', kind: 'insert', latex: '\\varangle' },
    { label: 'nexists', kind: 'insert', latex: '\\nexists' },
    { label: 'mho', kind: 'insert', latex: '\\mho' },
    { label: 'Finv', kind: 'insert', latex: '\\Finv' },
    { label: 'Game', kind: 'insert', latex: '\\Game' },
    { label: 'Bbbk', kind: 'insert', latex: '\\Bbbk' },
    { label: 'backprime', kind: 'insert', latex: '\\backprime' },
    { label: 'varnothing', kind: 'insert', latex: '\\varnothing' },
    { label: 'blacktriangle', kind: 'insert', latex: '\\blacktriangle' },
    { label: 'blacktriangledown', kind: 'insert', latex: '\\blacktriangledown' },
    { label: 'blacksquare', kind: 'insert', latex: '\\blacksquare' },
    { label: 'blacklozenge', kind: 'insert', latex: '\\blacklozenge' },
    { label: 'bigstar', kind: 'insert', latex: '\\bigstar' },
    { label: 'sphericalangle', kind: 'insert', latex: '\\sphericalangle' },
    { label: 'complement', kind: 'insert', latex: '\\complement' },
    { label: 'eth', kind: 'insert', latex: '\\eth' },
    { label: 'diagup', kind: 'insert', latex: '\\diagup' },
    { label: 'diagdown', kind: 'insert', latex: '\\diagdown' },
    { label: 'lightning', kind: 'insert', latex: '\\lightning' },
    { label: 'varcopyright', kind: 'insert', latex: '\\varcopyright' },
    { label: 'Bowtie', kind: 'insert', latex: '\\Bowtie' },
    { label: 'diameter', kind: 'insert', latex: '\\diameter' },
    { label: 'invdiameter', kind: 'insert', latex: '\\invdiameter' },
    { label: 'bell', kind: 'insert', latex: '\\bell' },
    { label: 'hexagon', kind: 'insert', latex: '\\hexagon' },
    { label: 'varhexagon', kind: 'insert', latex: '\\varhexagon' },
    { label: 'pentagon', kind: 'insert', latex: '\\pentagon' },
    { label: 'octagon', kind: 'insert', latex: '\\octagon' },
    { label: 'smiley', kind: 'insert', latex: '\\smiley' },
    { label: 'blacksmiley', kind: 'insert', latex: '\\blacksmiley' },
    { label: 'frownie', kind: 'insert', latex: '\\frownie' },
    { label: 'sun', kind: 'insert', latex: '\\sun' },
    { label: 'leadsto', kind: 'insert', latex: '\\leadsto' },
    { label: 'Circle', kind: 'insert', latex: '\\Circle' },
    { label: 'Leftcircle', kind: 'insert', latex: '\\Leftcircle' },
    { label: 'Rightcircle', kind: 'insert', latex: '\\Rightcircle' },
    { label: 'CIRCLE', kind: 'insert', latex: '\\CIRCLE' },
    { label: 'LEFTCIRCLE', kind: 'insert', latex: '\\LEFTCIRCLE' },
    { label: 'RIGHTCIRCLE', kind: 'insert', latex: '\\RIGHTCIRCLE' },
    { label: 'LEFTcircle', kind: 'insert', latex: '\\LEFTcircle' },
    { label: 'RIGHTcircle', kind: 'insert', latex: '\\RIGHTcircle' },
    { label: 'leftturn', kind: 'insert', latex: '\\leftturn' },
    { label: 'rightturn', kind: 'insert', latex: '\\rightturn' },
    { label: 'AC', kind: 'insert', latex: '\\AC' },
    { label: 'HF', kind: 'insert', latex: '\\HF' },
    { label: 'VHF', kind: 'insert', latex: '\\VHF' },
    { label: 'photon', kind: 'insert', latex: '\\photon' },
    { label: 'gluon', kind: 'insert', latex: '\\gluon' },
    { label: 'permil', kind: 'insert', latex: '\\permil' },
    { label: 'cent', kind: 'insert', latex: '\\cent' },
    { label: 'yen', kind: 'insert', latex: '\\yen' },
    { label: 'hexstar', kind: 'insert', latex: '\\hexstar' },
    { label: 'varhexstar', kind: 'insert', latex: '\\varhexstar' },
    { label: 'davidsstar', kind: 'insert', latex: '\\davidsstar' },
    { label: 'maltese', kind: 'insert', latex: '\\maltese' },
    { label: 'kreuz', kind: 'insert', latex: '\\kreuz' },
    { label: 'ataribox', kind: 'insert', latex: '\\ataribox' },
    { label: 'XBox', kind: 'insert', latex: '\\XBox' },
    { label: 'checked', kind: 'insert', latex: '\\checked' },
    { label: 'checkmark', kind: 'insert', latex: '\\checkmark' },
    { label: 'eighthnote', kind: 'insert', latex: '\\eighthnote' },
    { label: 'quarternote', kind: 'insert', latex: '\\quarternote' },
    { label: 'halfnote', kind: 'insert', latex: '\\halfnote' },
    { label: 'fullnote', kind: 'insert', latex: '\\fullnote' },
    { label: 'twonotes', kind: 'insert', latex: '\\twonotes' },
    { label: 'female', kind: 'insert', latex: '\\female' },
    { label: 'male', kind: 'insert', latex: '\\male' },
    { label: 'vernal', kind: 'insert', latex: '\\vernal' },
    { label: 'ascnode', kind: 'insert', latex: '\\ascnode' },
    { label: 'descnode', kind: 'insert', latex: '\\descnode' },
    { label: 'fullmoon', kind: 'insert', latex: '\\fullmoon' },
    { label: 'newmoon', kind: 'insert', latex: '\\newmoon' },
    { label: 'leftmoon', kind: 'insert', latex: '\\leftmoon' },
    { label: 'rightmoon', kind: 'insert', latex: '\\rightmoon' },
    { label: 'astrosun', kind: 'insert', latex: '\\astrosun' },
    { label: 'mercury', kind: 'insert', latex: '\\mercury' },
    { label: 'venus', kind: 'insert', latex: '\\venus' },
    { label: 'earth', kind: 'insert', latex: '\\earth' },
    { label: 'mars', kind: 'insert', latex: '\\mars' },
    { label: 'jupiter', kind: 'insert', latex: '\\jupiter' },
    { label: 'saturn', kind: 'insert', latex: '\\saturn' },
    { label: 'uranus', kind: 'insert', latex: '\\uranus' },
    { label: 'neptune', kind: 'insert', latex: '\\neptune' },
    { label: 'pluto', kind: 'insert', latex: '\\pluto' },
    { label: 'aries', kind: 'insert', latex: '\\aries' },
    { label: 'taurus', kind: 'insert', latex: '\\taurus' },
    { label: 'gemini', kind: 'insert', latex: '\\gemini' },
    { label: 'cancer', kind: 'insert', latex: '\\cancer' },
    { label: 'leo', kind: 'insert', latex: '\\leo' },
    { label: 'virgo', kind: 'insert', latex: '\\virgo' },
    { label: 'libra', kind: 'insert', latex: '\\libra' },
    { label: 'scorpio', kind: 'insert', latex: '\\scorpio' },
    { label: 'sagittarius', kind: 'insert', latex: '\\sagittarius' },
    { label: 'capricornus', kind: 'insert', latex: '\\capricornus' },
    { label: 'aquarius', kind: 'insert', latex: '\\aquarius' },
    { label: 'pisces', kind: 'insert', latex: '\\pisces' },
    { label: 'APLbox', kind: 'insert', latex: '\\APLbox' },
    { label: 'APLcomment', kind: 'insert', latex: '\\APLcomment' },
    { label: 'APLdown', kind: 'insert', latex: '\\APLdown' },
    { label: 'APLdownarrowbox', kind: 'insert', latex: '\\APLdownarrowbox' },
    { label: 'APLinput', kind: 'insert', latex: '\\APLinput' },
    { label: 'APLinv', kind: 'insert', latex: '\\APLinv' },
    { label: 'APLleftarrowbox', kind: 'insert', latex: '\\APLleftarrowbox' },
    { label: 'APLlog', kind: 'insert', latex: '\\APLlog' },
    { label: 'APLrightarrowbox', kind: 'insert', latex: '\\APLrightarrowbox' },
    { label: 'APLstar', kind: 'insert', latex: '\\APLstar' },
    { label: 'APLup', kind: 'insert', latex: '\\APLup' },
    { label: 'APLuparrowbox', kind: 'insert', latex: '\\APLuparrowbox' },
  ] },
  { id: 'latex_ams_arrows', title: 'Arrows (extended)', items: [
    { label: 'dashleftarrow', kind: 'insert', latex: '\\dashleftarrow' },
    { label: 'dashrightarrow', kind: 'insert', latex: '\\dashrightarrow' },
    { label: 'leftleftarrows', kind: 'insert', latex: '\\leftleftarrows' },
    { label: 'leftrightarrows', kind: 'insert', latex: '\\leftrightarrows' },
    { label: 'rightrightarrows', kind: 'insert', latex: '\\rightrightarrows' },
    { label: 'rightleftarrows', kind: 'insert', latex: '\\rightleftarrows' },
    { label: 'Lleftarrow', kind: 'insert', latex: '\\Lleftarrow' },
    { label: 'Rrightarrow', kind: 'insert', latex: '\\Rrightarrow' },
    { label: 'twoheadleftarrow', kind: 'insert', latex: '\\twoheadleftarrow' },
    { label: 'twoheadrightarrow', kind: 'insert', latex: '\\twoheadrightarrow' },
    { label: 'leftarrowtail', kind: 'insert', latex: '\\leftarrowtail' },
    { label: 'rightarrowtail', kind: 'insert', latex: '\\rightarrowtail' },
    { label: 'looparrowleft', kind: 'insert', latex: '\\looparrowleft' },
    { label: 'looparrowright', kind: 'insert', latex: '\\looparrowright' },
    { label: 'curvearrowleft', kind: 'insert', latex: '\\curvearrowleft' },
    { label: 'curvearrowright', kind: 'insert', latex: '\\curvearrowright' },
    { label: 'circlearrowleft', kind: 'insert', latex: '\\circlearrowleft' },
    { label: 'circlearrowright', kind: 'insert', latex: '\\circlearrowright' },
    { label: 'Lsh', kind: 'insert', latex: '\\Lsh' },
    { label: 'Rsh', kind: 'insert', latex: '\\Rsh' },
    { label: 'upuparrows', kind: 'insert', latex: '\\upuparrows' },
    { label: 'downdownarrows', kind: 'insert', latex: '\\downdownarrows' },
    { label: 'upharpoonleft', kind: 'insert', latex: '\\upharpoonleft' },
    { label: 'upharpoonright', kind: 'insert', latex: '\\upharpoonright' },
    { label: 'downharpoonleft', kind: 'insert', latex: '\\downharpoonleft' },
    { label: 'downharpoonright', kind: 'insert', latex: '\\downharpoonright' },
    { label: 'leftrightharpoons', kind: 'insert', latex: '\\leftrightharpoons' },
    { label: 'rightleftharpoons', kind: 'insert', latex: '\\rightleftharpoons' },
    { label: 'rightsquigarrow', kind: 'insert', latex: '\\rightsquigarrow' },
    { label: 'leftrightsquigarrow', kind: 'insert', latex: '\\leftrightsquigarrow' },
    { label: 'nleftarrow', kind: 'insert', latex: '\\nleftarrow' },
    { label: 'nrightarrow', kind: 'insert', latex: '\\nrightarrow' },
    { label: 'nleftrightarrow', kind: 'insert', latex: '\\nleftrightarrow' },
    { label: 'nLeftarrow', kind: 'insert', latex: '\\nLeftarrow' },
    { label: 'nRightarrow', kind: 'insert', latex: '\\nRightarrow' },
    { label: 'nLeftrightarrow', kind: 'insert', latex: '\\nLeftrightarrow' },
    { label: 'multimap', kind: 'insert', latex: '\\multimap' },
    { label: 'shortleftarrow', kind: 'insert', latex: '\\shortleftarrow' },
    { label: 'shortrightarrow', kind: 'insert', latex: '\\shortrightarrow' },
    { label: 'shortuparrow', kind: 'insert', latex: '\\shortuparrow' },
    { label: 'shortdownarrow', kind: 'insert', latex: '\\shortdownarrow' },
    { label: 'leftrightarroweq', kind: 'insert', latex: '\\leftrightarroweq' },
    { label: 'curlyveedownarrow', kind: 'insert', latex: '\\curlyveedownarrow' },
    { label: 'curlyveeuparrow', kind: 'insert', latex: '\\curlyveeuparrow' },
    { label: 'nnwarrow', kind: 'insert', latex: '\\nnwarrow' },
    { label: 'nnearrow', kind: 'insert', latex: '\\nnearrow' },
    { label: 'sswarrow', kind: 'insert', latex: '\\sswarrow' },
    { label: 'ssearrow', kind: 'insert', latex: '\\ssearrow' },
    { label: 'curlywedgeuparrow', kind: 'insert', latex: '\\curlywedgeuparrow' },
    { label: 'curlywedgedownarrow', kind: 'insert', latex: '\\curlywedgedownarrow' },
    { label: 'leftrightarrowtriangle', kind: 'insert', latex: '\\leftrightarrowtriangle' },
    { label: 'leftarrowtriangle', kind: 'insert', latex: '\\leftarrowtriangle' },
    { label: 'rightarrowtriangle', kind: 'insert', latex: '\\rightarrowtriangle' },
    { label: 'Mapsto', kind: 'insert', latex: '\\Mapsto' },
    { label: 'mapsfrom', kind: 'insert', latex: '\\mapsfrom' },
    { label: 'Mapsfrom', kind: 'insert', latex: '\\Mapsfrom' },
    { label: 'Longmapsto', kind: 'insert', latex: '\\Longmapsto' },
    { label: 'longmapsfrom', kind: 'insert', latex: '\\longmapsfrom' },
    { label: 'Longmapsfrom', kind: 'insert', latex: '\\Longmapsfrom' },
    { label: 'xleftarrow', kind: 'insert', latex: '\\xleftarrow' },
    { label: 'xrightarrow', kind: 'insert', latex: '\\xrightarrow' },
  ] },
  { id: 'latex_ams_rel', title: 'Relations (extended)', items: [
    { label: 'leqq', kind: 'insert', latex: '\\leqq' },
    { label: 'geqq', kind: 'insert', latex: '\\geqq' },
    { label: 'leqslant', kind: 'insert', latex: '\\leqslant' },
    { label: 'geqslant', kind: 'insert', latex: '\\geqslant' },
    { label: 'eqslantless', kind: 'insert', latex: '\\eqslantless' },
    { label: 'eqslantgtr', kind: 'insert', latex: '\\eqslantgtr' },
    { label: 'eqsim', kind: 'insert', latex: '\\eqsim' },
    { label: 'lesssim', kind: 'insert', latex: '\\lesssim' },
    { label: 'gtrsim', kind: 'insert', latex: '\\gtrsim' },
    { label: 'apprge', kind: 'insert', latex: '\\apprge' },
    { label: 'apprle', kind: 'insert', latex: '\\apprle' },
    { label: 'lessapprox', kind: 'insert', latex: '\\lessapprox' },
    { label: 'gtrapprox', kind: 'insert', latex: '\\gtrapprox' },
    { label: 'approxeq', kind: 'insert', latex: '\\approxeq' },
    { label: 'triangleq', kind: 'insert', latex: '\\triangleq' },
    { label: 'lessdot', kind: 'insert', latex: '\\lessdot' },
    { label: 'gtrdot', kind: 'insert', latex: '\\gtrdot' },
    { label: 'lll', kind: 'insert', latex: '\\lll' },
    { label: 'ggg', kind: 'insert', latex: '\\ggg' },
    { label: 'lessgtr', kind: 'insert', latex: '\\lessgtr' },
    { label: 'gtrless', kind: 'insert', latex: '\\gtrless' },
    { label: 'lesseqgtr', kind: 'insert', latex: '\\lesseqgtr' },
    { label: 'gtreqless', kind: 'insert', latex: '\\gtreqless' },
    { label: 'lesseqqgtr', kind: 'insert', latex: '\\lesseqqgtr' },
    { label: 'gtreqqless', kind: 'insert', latex: '\\gtreqqless' },
    { label: 'eqcirc', kind: 'insert', latex: '\\eqcirc' },
    { label: 'circeq', kind: 'insert', latex: '\\circeq' },
    { label: 'thicksim', kind: 'insert', latex: '\\thicksim' },
    { label: 'thickapprox', kind: 'insert', latex: '\\thickapprox' },
    { label: 'backsim', kind: 'insert', latex: '\\backsim' },
    { label: 'backsimeq', kind: 'insert', latex: '\\backsimeq' },
    { label: 'subseteqq', kind: 'insert', latex: '\\subseteqq' },
    { label: 'supseteqq', kind: 'insert', latex: '\\supseteqq' },
    { label: 'Subset', kind: 'insert', latex: '\\Subset' },
    { label: 'Supset', kind: 'insert', latex: '\\Supset' },
    { label: 'sqsubset', kind: 'insert', latex: '\\sqsubset' },
    { label: 'sqsupset', kind: 'insert', latex: '\\sqsupset' },
    { label: 'preccurlyeq', kind: 'insert', latex: '\\preccurlyeq' },
    { label: 'succcurlyeq', kind: 'insert', latex: '\\succcurlyeq' },
    { label: 'curlyeqprec', kind: 'insert', latex: '\\curlyeqprec' },
    { label: 'curlyeqsucc', kind: 'insert', latex: '\\curlyeqsucc' },
    { label: 'precsim', kind: 'insert', latex: '\\precsim' },
    { label: 'succsim', kind: 'insert', latex: '\\succsim' },
    { label: 'precapprox', kind: 'insert', latex: '\\precapprox' },
    { label: 'succapprox', kind: 'insert', latex: '\\succapprox' },
    { label: 'vartriangleleft', kind: 'insert', latex: '\\vartriangleleft' },
    { label: 'vartriangleright', kind: 'insert', latex: '\\vartriangleright' },
    { label: 'trianglelefteq', kind: 'insert', latex: '\\trianglelefteq' },
    { label: 'trianglerighteq', kind: 'insert', latex: '\\trianglerighteq' },
    { label: 'bumpeq', kind: 'insert', latex: '\\bumpeq' },
    { label: 'Bumpeq', kind: 'insert', latex: '\\Bumpeq' },
    { label: 'doteqdot', kind: 'insert', latex: '\\doteqdot' },
    { label: 'risingdotseq', kind: 'insert', latex: '\\risingdotseq' },
    { label: 'fallingdotseq', kind: 'insert', latex: '\\fallingdotseq' },
    { label: 'vDash', kind: 'insert', latex: '\\vDash' },
    { label: 'Vvdash', kind: 'insert', latex: '\\Vvdash' },
    { label: 'Vdash', kind: 'insert', latex: '\\Vdash' },
    { label: 'shortmid', kind: 'insert', latex: '\\shortmid' },
    { label: 'shortparallel', kind: 'insert', latex: '\\shortparallel' },
    { label: 'smallsmile', kind: 'insert', latex: '\\smallsmile' },
    { label: 'smallfrown', kind: 'insert', latex: '\\smallfrown' },
    { label: 'blacktriangleleft', kind: 'insert', latex: '\\blacktriangleleft' },
    { label: 'blacktriangleright', kind: 'insert', latex: '\\blacktriangleright' },
    { label: 'because', kind: 'insert', latex: '\\because' },
    { label: 'therefore', kind: 'insert', latex: '\\therefore' },
    { label: 'wasytherefore', kind: 'insert', latex: '\\wasytherefore' },
    { label: 'backepsilon', kind: 'insert', latex: '\\backepsilon' },
    { label: 'varpropto', kind: 'insert', latex: '\\varpropto' },
    { label: 'between', kind: 'insert', latex: '\\between' },
    { label: 'pitchfork', kind: 'insert', latex: '\\pitchfork' },
    { label: 'trianglelefteqslant', kind: 'insert', latex: '\\trianglelefteqslant' },
    { label: 'trianglerighteqslant', kind: 'insert', latex: '\\trianglerighteqslant' },
    { label: 'inplus', kind: 'insert', latex: '\\inplus' },
    { label: 'niplus', kind: 'insert', latex: '\\niplus' },
    { label: 'subsetplus', kind: 'insert', latex: '\\subsetplus' },
    { label: 'supsetplus', kind: 'insert', latex: '\\supsetplus' },
    { label: 'subsetpluseq', kind: 'insert', latex: '\\subsetpluseq' },
    { label: 'supsetpluseq', kind: 'insert', latex: '\\supsetpluseq' },
    { label: 'minuso', kind: 'insert', latex: '\\minuso' },
    { label: 'baro', kind: 'insert', latex: '\\baro' },
    { label: 'sslash', kind: 'insert', latex: '\\sslash' },
    { label: 'bbslash', kind: 'insert', latex: '\\bbslash' },
    { label: 'moo', kind: 'insert', latex: '\\moo' },
    { label: 'merge', kind: 'insert', latex: '\\merge' },
    { label: 'invneg', kind: 'insert', latex: '\\invneg' },
    { label: 'lbag', kind: 'insert', latex: '\\lbag' },
    { label: 'rbag', kind: 'insert', latex: '\\rbag' },
    { label: 'interleave', kind: 'insert', latex: '\\interleave' },
    { label: 'leftslice', kind: 'insert', latex: '\\leftslice' },
    { label: 'rightslice', kind: 'insert', latex: '\\rightslice' },
    { label: 'oblong', kind: 'insert', latex: '\\oblong' },
    { label: 'talloblong', kind: 'insert', latex: '\\talloblong' },
    { label: 'fatsemi', kind: 'insert', latex: '\\fatsemi' },
    { label: 'fatslash', kind: 'insert', latex: '\\fatslash' },
    { label: 'fatbslash', kind: 'insert', latex: '\\fatbslash' },
    { label: 'ldotp', kind: 'insert', latex: '\\ldotp' },
    { label: 'cdotp', kind: 'insert', latex: '\\cdotp' },
    { label: 'colon', kind: 'insert', latex: '\\colon' },
    { label: 'dblcolon', kind: 'insert', latex: '\\dblcolon' },
    { label: 'vcentcolon', kind: 'insert', latex: '\\vcentcolon' },
    { label: 'colonapprox', kind: 'insert', latex: '\\colonapprox' },
    { label: 'Colonapprox', kind: 'insert', latex: '\\Colonapprox' },
    { label: 'coloneq', kind: 'insert', latex: '\\coloneq' },
    { label: 'Coloneq', kind: 'insert', latex: '\\Coloneq' },
    { label: 'coloneqq', kind: 'insert', latex: '\\coloneqq' },
    { label: 'Coloneqq', kind: 'insert', latex: '\\Coloneqq' },
    { label: 'colonsim', kind: 'insert', latex: '\\colonsim' },
    { label: 'Colonsim', kind: 'insert', latex: '\\Colonsim' },
    { label: 'eqcolon', kind: 'insert', latex: '\\eqcolon' },
    { label: 'Eqcolon', kind: 'insert', latex: '\\Eqcolon' },
    { label: 'eqqcolon', kind: 'insert', latex: '\\eqqcolon' },
    { label: 'Eqqcolon', kind: 'insert', latex: '\\Eqqcolon' },
    { label: 'wasypropto', kind: 'insert', latex: '\\wasypropto' },
    { label: 'logof', kind: 'insert', latex: '\\logof' },
    { label: 'Join', kind: 'insert', latex: '\\Join' },
  ] },
  { id: 'latex_ams_nrel', title: 'Negative Relations (extended)', items: [
    { label: 'nless', kind: 'insert', latex: '\\nless' },
    { label: 'ngtr', kind: 'insert', latex: '\\ngtr' },
    { label: 'nleq', kind: 'insert', latex: '\\nleq' },
    { label: 'ngeq', kind: 'insert', latex: '\\ngeq' },
    { label: 'nleqslant', kind: 'insert', latex: '\\nleqslant' },
    { label: 'ngeqslant', kind: 'insert', latex: '\\ngeqslant' },
    { label: 'nleqq', kind: 'insert', latex: '\\nleqq' },
    { label: 'ngeqq', kind: 'insert', latex: '\\ngeqq' },
    { label: 'lneq', kind: 'insert', latex: '\\lneq' },
    { label: 'gneq', kind: 'insert', latex: '\\gneq' },
    { label: 'lneqq', kind: 'insert', latex: '\\lneqq' },
    { label: 'gneqq', kind: 'insert', latex: '\\gneqq' },
    { label: 'lvertneqq', kind: 'insert', latex: '\\lvertneqq' },
    { label: 'gvertneqq', kind: 'insert', latex: '\\gvertneqq' },
    { label: 'lnsim', kind: 'insert', latex: '\\lnsim' },
    { label: 'gnsim', kind: 'insert', latex: '\\gnsim' },
    { label: 'lnapprox', kind: 'insert', latex: '\\lnapprox' },
    { label: 'gnapprox', kind: 'insert', latex: '\\gnapprox' },
    { label: 'nprec', kind: 'insert', latex: '\\nprec' },
    { label: 'nsucc', kind: 'insert', latex: '\\nsucc' },
    { label: 'npreceq', kind: 'insert', latex: '\\npreceq' },
    { label: 'nsucceq', kind: 'insert', latex: '\\nsucceq' },
    { label: 'precneqq', kind: 'insert', latex: '\\precneqq' },
    { label: 'succneqq', kind: 'insert', latex: '\\succneqq' },
    { label: 'precnsim', kind: 'insert', latex: '\\precnsim' },
    { label: 'succnsim', kind: 'insert', latex: '\\succnsim' },
    { label: 'precnapprox', kind: 'insert', latex: '\\precnapprox' },
    { label: 'succnapprox', kind: 'insert', latex: '\\succnapprox' },
    { label: 'subsetneq', kind: 'insert', latex: '\\subsetneq' },
    { label: 'supsetneq', kind: 'insert', latex: '\\supsetneq' },
    { label: 'subsetneqq', kind: 'insert', latex: '\\subsetneqq' },
    { label: 'supsetneqq', kind: 'insert', latex: '\\supsetneqq' },
    { label: 'nsubseteq', kind: 'insert', latex: '\\nsubseteq' },
    { label: 'nsubseteqq', kind: 'insert', latex: '\\nsubseteqq' },
    { label: 'nsupseteq', kind: 'insert', latex: '\\nsupseteq' },
    { label: 'nsupseteqq', kind: 'insert', latex: '\\nsupseteqq' },
    { label: 'nvdash', kind: 'insert', latex: '\\nvdash' },
    { label: 'nvDash', kind: 'insert', latex: '\\nvDash' },
    { label: 'nVDash', kind: 'insert', latex: '\\nVDash' },
    { label: 'nVdash', kind: 'insert', latex: '\\nVdash' },
    { label: 'varsubsetneq', kind: 'insert', latex: '\\varsubsetneq' },
    { label: 'varsupsetneq', kind: 'insert', latex: '\\varsupsetneq' },
    { label: 'varsubsetneqq', kind: 'insert', latex: '\\varsubsetneqq' },
    { label: 'varsupsetneqq', kind: 'insert', latex: '\\varsupsetneqq' },
    { label: 'ntriangleleft', kind: 'insert', latex: '\\ntriangleleft' },
    { label: 'ntriangleright', kind: 'insert', latex: '\\ntriangleright' },
    { label: 'ntrianglelefteq', kind: 'insert', latex: '\\ntrianglelefteq' },
    { label: 'ntrianglerighteq', kind: 'insert', latex: '\\ntrianglerighteq' },
    { label: 'ncong', kind: 'insert', latex: '\\ncong' },
    { label: 'nsim', kind: 'insert', latex: '\\nsim' },
    { label: 'nmid', kind: 'insert', latex: '\\nmid' },
    { label: 'nshortmid', kind: 'insert', latex: '\\nshortmid' },
    { label: 'nparallel', kind: 'insert', latex: '\\nparallel' },
    { label: 'nshortparallel', kind: 'insert', latex: '\\nshortparallel' },
    { label: 'ntrianglelefteqslant', kind: 'insert', latex: '\\ntrianglelefteqslant' },
    { label: 'ntrianglerighteqslant', kind: 'insert', latex: '\\ntrianglerighteqslant' },
  ] },
  { id: 'latex_ams_ops', title: 'Operators (extended)', items: [
    { label: 'dotplus', kind: 'insert', latex: '\\dotplus' },
    { label: 'smallsetminus', kind: 'insert', latex: '\\smallsetminus' },
    { label: 'Cap', kind: 'insert', latex: '\\Cap' },
    { label: 'Cup', kind: 'insert', latex: '\\Cup' },
    { label: 'barwedge', kind: 'insert', latex: '\\barwedge' },
    { label: 'veebar', kind: 'insert', latex: '\\veebar' },
    { label: 'doublebarwedge', kind: 'insert', latex: '\\doublebarwedge' },
    { label: 'boxminus', kind: 'insert', latex: '\\boxminus' },
    { label: 'boxtimes', kind: 'insert', latex: '\\boxtimes' },
    { label: 'boxdot', kind: 'insert', latex: '\\boxdot' },
    { label: 'boxplus', kind: 'insert', latex: '\\boxplus' },
    { label: 'boxast', kind: 'insert', latex: '\\boxast' },
    { label: 'boxbar', kind: 'insert', latex: '\\boxbar' },
    { label: 'boxslash', kind: 'insert', latex: '\\boxslash' },
    { label: 'boxbslash', kind: 'insert', latex: '\\boxbslash' },
    { label: 'boxcircle', kind: 'insert', latex: '\\boxcircle' },
    { label: 'boxbox', kind: 'insert', latex: '\\boxbox' },
    { label: 'boxempty', kind: 'insert', latex: '\\boxempty' },
    { label: 'divideontimes', kind: 'insert', latex: '\\divideontimes' },
    { label: 'ltimes', kind: 'insert', latex: '\\ltimes' },
    { label: 'rtimes', kind: 'insert', latex: '\\rtimes' },
    { label: 'leftthreetimes', kind: 'insert', latex: '\\leftthreetimes' },
    { label: 'rightthreetimes', kind: 'insert', latex: '\\rightthreetimes' },
    { label: 'curlywedge', kind: 'insert', latex: '\\curlywedge' },
    { label: 'curlyvee', kind: 'insert', latex: '\\curlyvee' },
    { label: 'circleddash', kind: 'insert', latex: '\\circleddash' },
    { label: 'circledast', kind: 'insert', latex: '\\circledast' },
    { label: 'circledcirc', kind: 'insert', latex: '\\circledcirc' },
    { label: 'centerdot', kind: 'insert', latex: '\\centerdot' },
    { label: 'intercal', kind: 'insert', latex: '\\intercal' },
    { label: 'implies', kind: 'insert', latex: '\\implies' },
    { label: 'impliedby', kind: 'insert', latex: '\\impliedby' },
    { label: 'bigcurlyvee', kind: 'insert', latex: '\\bigcurlyvee' },
    { label: 'bigcurlywedge', kind: 'insert', latex: '\\bigcurlywedge' },
    { label: 'bigsqcap', kind: 'insert', latex: '\\bigsqcap' },
    { label: 'bigbox', kind: 'insert', latex: '\\bigbox' },
    { label: 'bigparallel', kind: 'insert', latex: '\\bigparallel' },
    { label: 'biginterleave', kind: 'insert', latex: '\\biginterleave' },
    { label: 'bignplus', kind: 'insert', latex: '\\bignplus' },
    { label: 'nplus', kind: 'insert', latex: '\\nplus' },
    { label: 'Yup', kind: 'insert', latex: '\\Yup' },
    { label: 'Ydown', kind: 'insert', latex: '\\Ydown' },
    { label: 'Yleft', kind: 'insert', latex: '\\Yleft' },
    { label: 'Yright', kind: 'insert', latex: '\\Yright' },
    { label: 'obar', kind: 'insert', latex: '\\obar' },
    { label: 'obslash', kind: 'insert', latex: '\\obslash' },
    { label: 'ocircle', kind: 'insert', latex: '\\ocircle' },
    { label: 'olessthan', kind: 'insert', latex: '\\olessthan' },
    { label: 'ogreaterthan', kind: 'insert', latex: '\\ogreaterthan' },
    { label: 'ovee', kind: 'insert', latex: '\\ovee' },
    { label: 'owedge', kind: 'insert', latex: '\\owedge' },
    { label: 'varcurlyvee', kind: 'insert', latex: '\\varcurlyvee' },
    { label: 'varcurlywedge', kind: 'insert', latex: '\\varcurlywedge' },
    { label: 'vartimes', kind: 'insert', latex: '\\vartimes' },
    { label: 'varotimes', kind: 'insert', latex: '\\varotimes' },
    { label: 'varoast', kind: 'insert', latex: '\\varoast' },
    { label: 'varobar', kind: 'insert', latex: '\\varobar' },
    { label: 'varodot', kind: 'insert', latex: '\\varodot' },
    { label: 'varoslash', kind: 'insert', latex: '\\varoslash' },
    { label: 'varobslash', kind: 'insert', latex: '\\varobslash' },
    { label: 'varocircle', kind: 'insert', latex: '\\varocircle' },
    { label: 'varoplus', kind: 'insert', latex: '\\varoplus' },
    { label: 'varominus', kind: 'insert', latex: '\\varominus' },
    { label: 'varovee', kind: 'insert', latex: '\\varovee' },
    { label: 'varowedge', kind: 'insert', latex: '\\varowedge' },
    { label: 'varolessthan', kind: 'insert', latex: '\\varolessthan' },
    { label: 'varogreaterthan', kind: 'insert', latex: '\\varogreaterthan' },
    { label: 'varbigcirc', kind: 'insert', latex: '\\varbigcirc' },
  ] },
  { id: 'latex_delim', title: 'Delimiters (fixed size)', items: [
    { label: 'brokenvert', kind: 'insert', latex: '\\brokenvert' },
    { label: 'lfloor', kind: 'insert', latex: '\\lfloor' },
    { label: 'rfloor', kind: 'insert', latex: '\\rfloor' },
    { label: 'lceil', kind: 'insert', latex: '\\lceil' },
    { label: 'rceil', kind: 'insert', latex: '\\rceil' },
    { label: 'llbracket', kind: 'insert', latex: '\\llbracket' },
    { label: 'rrbracket', kind: 'insert', latex: '\\rrbracket' },
    { label: 'llfloor', kind: 'insert', latex: '\\llfloor' },
    { label: 'rrfloor', kind: 'insert', latex: '\\rrfloor' },
    { label: 'llceil', kind: 'insert', latex: '\\llceil' },
    { label: 'rrceil', kind: 'insert', latex: '\\rrceil' },
    { label: 'Lbag', kind: 'insert', latex: '\\Lbag' },
    { label: 'Rbag', kind: 'insert', latex: '\\Rbag' },
    { label: 'llparenthesis', kind: 'insert', latex: '\\llparenthesis' },
    { label: 'rrparenthesis', kind: 'insert', latex: '\\rrparenthesis' },
    { label: 'binampersand', kind: 'insert', latex: '\\binampersand' },
    { label: 'bindnasrepma', kind: 'insert', latex: '\\bindnasrepma' },
  ] },
];
